import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ArrowIcon from "../components/icons/Arrow";

const TelegramCheckout = () => {
  const navigate = useNavigate();
  const [checkoutUrl] = useState(() =>
    sessionStorage.getItem("telegram_checkout_url")
  );
  const returnPath =
    sessionStorage.getItem("telegram_checkout_return") ||
    "/latest-tenders/telegram";

  const goBack = () => {
    sessionStorage.removeItem("telegram_checkout_url");
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(returnPath);
    }
  };

  const openCheckout = () => {
    if (!checkoutUrl) return;
    if (window.Telegram?.WebApp?.openLink) {
      window.Telegram.WebApp.openLink(checkoutUrl);
    } else {
      window.location.assign(checkoutUrl);
    }
  };

  useEffect(() => {
    if (!checkoutUrl) {
      navigate(returnPath, { replace: true });
      return;
    }

    const backButton = window.Telegram?.WebApp?.BackButton;
    window.Telegram?.WebApp?.expand();
    window.Telegram?.WebApp?.MainButton?.hide();
    backButton?.show();
    backButton?.onClick(goBack);
    openCheckout();

    return () => {
      backButton?.offClick(goBack);
      backButton?.hide();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutUrl]);

  if (!checkoutUrl) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[200] flex flex-col bg-[#f8f8ff]">
      <header className="flex items-center gap-3 px-4 h-[56px] bg-white/90 backdrop-blur-sm border-b border-slate-200 shrink-0">
        <button
          type="button"
          onClick={goBack}
          aria-label="Back to iChereta"
          className="flex items-center justify-center text-[#664bc7] -ml-1"
        >
          <ArrowIcon styles="w-6 h-6 rotate-180" />
        </button>
        <div className="min-w-0">
          <h1 className="text-base font-semibold text-[#3d5984] truncate">
            Payment
          </h1>
          <p className="text-[11px] text-[#3d5984]/60">
            Telegram back returns to iChereta
          </p>
        </div>
      </header>

      <div className="flex-1 flex flex-col items-center justify-center px-8 text-center">
        <h2 className="text-lg font-semibold text-[#3d5984]">
          Complete payment in the window that opened
        </h2>
        <p className="mt-2 text-sm text-[#3d5984]/70 max-w-[320px]">
          Chapa can’t run inside the Mini App. After you pay, close that window
          and use Telegram back to return here.
        </p>
        <button
          type="button"
          onClick={openCheckout}
          className="mt-6 w-full max-w-[320px] py-3 rounded-full bg-[#664bc7] text-white font-semibold"
        >
          Open payment again
        </button>
        <button
          type="button"
          onClick={goBack}
          className="mt-3 text-sm font-medium text-[#664bc7]"
        >
          Back to iChereta
        </button>
      </div>
    </div>
  );
};

export default TelegramCheckout;
